import { Product } from "../models"
import {
  ProductCarousel,
  ProductList,
  ProductDetailPopover,
} from "../components"

import { Layout } from "@/layout/components"
import { Tag } from "@/tag/models"
import { TagNavigator } from "@/tag/components"
import { config } from "@/config"
import { Profile } from "@/profile/models"

import Vue from "vue"
import { Component, Watch } from "vue-property-decorator"
import { ListResponse, Api } from "@/api"

@Component({
  components: {
    Layout,
    TagNavigator,
    ProductCarousel,
    ProductList,
    ProductDetailPopover,
  },
})
export default class ListProductsPage extends Vue {
  activeTag: Tag | null = null
  productListResponse: ListResponse<Product> | null = null
  profile: Profile | null = null
  detailProductId: string | null = null

  async mounted() {
    const profileData = JSON.parse(
      window.localStorage.getItem(config.profileStorageKey) || "null",
    )

    if (profileData !== null) {
      this.profile = profileData
    }

    const tagId: string | undefined =
      (this.$route.query.activeTagId as string) || undefined

    await this.reloadActiveTag(tagId)
    this.reloadProducts()
  }

  async reloadProducts(offset = 0, limit = 50) {
    const api = Api.createFromEnv()
    const options = { offset: offset.toString(), limit: limit.toString() }

    if (this.activeTag !== null) {
      options["tag__product_has"] = this.activeTag._id
    }

    this.productListResponse = await api
      .getList<Product>("products", options)
      .catch(error => {
        console.error(error)

        return null
      })
  }

  async reloadActiveTag(tagId?: string) {
    const api = Api.createFromEnv()
    const options = { limit: "1" }

    if (tagId !== undefined) {
      options["_id__eq_id"] = tagId
    }

    const response = await api.getList<Tag>("tags", options).catch(error => {
      console.error(error)
      return null
    })

    if (response !== null && response.items.length > 0) {
      this.activeTag = response.items[0]
    }

    const { detailProductId } = this.$route.query

    if (typeof detailProductId === "string") {
      this.detailProductId = detailProductId
    }
  }

  onTagClick(tag: Tag) {
    this.activeTag = tag

    this.$router
      .push({
        path: "products",
        query: { ...this.$route.query, activeTagId: tag._id },
      })
      .catch(() => {})
  }

  get featuredProductsOptions() {
    return { featured__eq_boolean: true, limit: 999 }
  }

  @Watch("$route.query.activeTagId")
  onActiveTagIdQueryChange(value) {
    if (typeof value === "string") {
      this.reloadActiveTag(value)
      this.reloadProducts()
    }
  }

  @Watch("$route.query.detailProductId")
  onDetailProductIdQueryChange(value) {
    if (typeof value === "string") {
      this.detailProductId = value as string
    } else {
      this.detailProductId = null
    }
  }

  getHomeUrl(): string {
    let url = ""

    if (this.profile !== null) {
      url = config.portalUrl
    } else {
      url = config.landingPageUrl
    }

    return url
  }

  onProductClick(product: Product) {
    this.$router
      .push({
        path: "products",
        query: { ...this.$route.query, detailProductId: product._id },
      })
      .catch(() => {})
  }

  onDetailPopoverClose() {
    this.$router
      .push({
        path: "products",
        query: { ...this.$route.query, detailProductId: undefined },
      })
      .catch(() => {})
  }
}
